import _forEach from 'lodash/forEach';
import templateCompiler from './template-compiler';

const lodash = { _forEach };

const html = `
<% if (suggestions.length > 0){ %>
  <ul class="ajax-search-results">
    <% _forEach(suggestions, function (product){ %>
      <li class="ajax-search-item">
        <a href="<%- product.url %>" class="ajax-search-link"><%= product.markedTitle %></a>
      </li>
    <% }) %>
  </ul>
<% } %>`;

export default templateCompiler(html, lodash);
